import Vue from 'vue'
import Element from 'element-ui'
import '../assets/scss/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/display.css';

Vue.use(Element, { locale })
